import MenuItem from "@mui/material/MenuItem"
import { makeStyles } from "tss-react/mui"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ResourceType } from "../../../../../serviceCenter/admin/organization/resources/resourcesTypes"
import { createEnumChecker, iterateStringEnum } from "../../../../../../lib/enums"
import { LabeledFilterSelect } from "./LabeledFilterSelect"

const isResourceType = createEnumChecker(ResourceType)

type ResourceTypeFilterProps = Readonly<{
    value: ResourceType
    onChange: (type: ResourceType) => void
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "15rem",
    },
}))

export function ResourceTypeFilter({ value, onChange }: ResourceTypeFilterProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="table-select-resource-type-filter-by-label-label" attrs={{ label: true }}>
            <LabeledFilterSelect
                id="multiple-checkbox-resource-type"
                label="Resource type"
                value={value}
                onChange={(next) => {
                    if (isResourceType(next)) onChange(next)
                }}
                className={classes.input}
            >
                {[...iterateStringEnum(ResourceType)].map((value) => (
                    <MenuItem key={value} value={value}>
                        <LocalizedEnum base="table-select-resource-type-filter-by" enumValue={value}>
                            <span>{value}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </LabeledFilterSelect>
        </LocalizedStrict>
    )
}
